<script>
  import MapboxMap from "./mapbox/MapboxMap.vue";
  import {
    USA_CENTER_LON_LAT,
    INITIAL_MAP_MAX_ZOOM,
    INITIAL_MAP_MIN_ZOOM,
  } from "./constants";

  export default {
    name: "StoreLocatorMap",
    components: { MapboxMap },
    props: {
      mapProvider: { required: true, type: String },
      primaryMapStyle: { required: false, type: String, default: "" },
      primaryMapStyleName: { required: false, type: String, default: "" },
      secondaryMapStyle: { required: false, type: String, default: "" },
      secondaryMapStyleName: { required: false, type: String, default: "" },
      mapStyleToggleLabel: {
        required: false,
        type: String,
        default: "Change Maps",
      },
      mapStyleDesktopPopover: { required: false, type: Boolean, default: true },
      locations: {
        type: Array,
        required: false,
      },
      businessTypes: {
        type: Array,
        required: false,
      },
      geoJsonStyles: {
        type: Object,
        required: false,
      },
      focusedLocation: { required: false },
      center: { required: false, type: Array },
      searchLatLon: { required: false, type: Array },
      minZoom: {
        type: Number,
        required: false,
        default: INITIAL_MAP_MIN_ZOOM,
      },
      maxZoom: {
        type: Number,
        required: false,
        default: INITIAL_MAP_MAX_ZOOM,
      },
      closureMessage: {
        type: String,
        required: true,
      },
      pendingOpeningMessage: {
        type: String,
        required: true,
      },
      markerColor: {
        required: false,
        type: String,
        default: "#370c4f",
        // TODO How to load this in dynamically? Potential to use computed prop on the StoreLocator
        // component, using a config, provided by the backend
      },
      iconLibrary: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        loading: true,
        mapCenter: USA_CENTER_LON_LAT,
      };
    },
    computed: {
      selectedMap() {
        switch (this.mapProvider) {
          case "Mapbox":
            return MapboxMap;
          default:
            return MapboxMap;
        }
      },
    },
  };
</script>

<template>
  <!-- Transparent wrapper component for any Map Provider -->
  <!-- v-bind="$props" and maps StoreLocator props onto the dynamic component -->
  <!-- v-bind="$attrs" for everything not declared as props including listeners -->
  <!-- eslint-disable vue/no-deprecated-dollar-listeners-api -->
  <component :is="selectedMap" v-bind="$props" v-on="$listeners"></component>
</template>
